import Box from '@zenbusiness/zui/Box';
import DialogContent from '@zenbusiness/zui/DialogContent';
import Link from '@zenbusiness/zui/Link';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';
import { tooltipClasses } from '@zenbusiness/zui/Tooltip';

export const DialogContentStyled = styled(DialogContent)(({ theme }) => ({
  padding: '0',
  backgroundColor: theme.palette.background.grey.main
}));

export const Wrapper = styled(Stack)(({ theme }) => ({
  width: '100%',

  gridColumn: '1 / span 4',

  [theme.breakpoints.up('sm')]: {
    gridColumn: '2 / span 4'
  },

  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / span 6'
  },

  [theme.breakpoints.up('lg')]: {
    gridColumn: '4 / span 6'
  }
}));

export const BoxStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isDisable'
})(({ theme, isDisable }) => ({
  padding: '24px 16px',
  border: `1px solid ${theme.palette.border.dark}`,
  borderRadius: '16px',
  cursor: isDisable ? 'not-allowed' : 'pointer',
  background: isDisable ? theme.palette.background.grey.dark : theme.palette.background.grey.light,
  opacity: isDisable ? 0.7 : 'initial'
}));

export const FieldContainerStyled = styled('div')(({ theme }) => ({
  padding: '16px 24px',
  borderRadius: '16px',
  border: `1px solid ${theme.palette.border.dark}`,
  backgroundColor: theme.palette.background.grey.light
}));

export const WrapContentStyled = styled(Box)(() => ({
  marginLeft: '34px'
}));

export const GroupTextInputStyled = styled(Box)(() => ({
  margin: '0px',
  '& .MuiInputBase-input': {
    zIndex: 2
  }
}));

export const WrapInstitutionNameStyled = styled(Stack)(() => ({
  img: {
    objectFit: 'contain'
  }
}));

export const LinkStyled = styled(Link)(() => ({
  cursor: 'pointer'
}));

export const TooltipStyle = ({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    height: 'max-content',
    padding: '8px 14px',
    borderRadius: '12px',
    backgroundColor: theme.palette.fixed.black
  }
});

export const SecurelyStyled = styled(Stack)(({ theme }) => ({
  maxWidth: 'max-content',
  borderRadius: '16px',
  padding: '16px 24px',
  backgroundColor: theme.palette.background.grey.main
}));

export const TitleStyle = ({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: 800
  }
});
